// extracted by mini-css-extract-plugin
export default {"palleteContainer":"LabelPallete_palleteContainer__IS9e9","labelOption":"LabelPallete_labelOption__XwsTS"};